var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":"","x-small":""},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.$t("copySms"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }